import React from "react";
import { Sidebar } from "flowbite-react";
import { HiHome, HiInbox } from "react-icons/hi";
import { MdOutlineAccountCircle } from "react-icons/md";
import { PiNoteBlankFill } from "react-icons/pi";
import { BiSolidSelectMultiple } from "react-icons/bi";
import { GiNotebook } from "react-icons/gi";
import { MdQuestionAnswer } from "react-icons/md";
import { FaRankingStar } from "react-icons/fa6";
import { MdOutlineCompareArrows } from "react-icons/md";
import { TiSortNumericallyOutline } from "react-icons/ti";
import { Link, useLocation } from "react-router-dom";

export default function SidebarPanel() {
  const location = useLocation();

  return (
    <Sidebar
      aria-label="Sidebar with content separator example"
      className="w-64 bg-primary shadow-md flex flex-col quiz_sidebar fixed top-[1.5vh] left-0 max-h-[95vh] h-[95vh] rounded-lg overflow-hidden"
    >
      <Sidebar.Items className="flex-1 overflow-y-auto">
        <Sidebar.ItemGroup>
          <Sidebar.Item
            as={Link}
            to="/dashboard"
            icon={HiHome}
            className={`text-white p-2.5 hover:bg-secondary ${
              location.pathname === "/dashboard"
                ? "bg-secondary text-black active"
                : ""
            }`}
          >
            Home
          </Sidebar.Item>
          <Sidebar.Item
            as={Link}
            to="/multi-choice"
            icon={BiSolidSelectMultiple}
            className={`text-white p-2.5 hover:bg-secondary ${
              location.pathname === "/multi-choice"
                ? "bg-secondary text-black active"
                : ""
            }`}
          >
            Multiple choice
          </Sidebar.Item>
          <Sidebar.Item
            as={Link}
            to="/true-or-false"
            icon={HiInbox}
            className={`text-white p-2.5 hover:bg-secondary ${
              location.pathname === "/true-or-false"
                ? "bg-secondary text-black active"
                : ""
            }`}
          >
            True/False
          </Sidebar.Item>
          <Sidebar.Item
            as={Link}
            to="/short-answer"
            icon={MdQuestionAnswer}
            className={`text-white p-2.5 hover:bg-secondary ${
              location.pathname === "/short-answer"
                ? "bg-secondary text-black active"
                : ""
            }`}
          >
            Short answer
          </Sidebar.Item>
          <Sidebar.Item
            as={Link}
            to="/fill-in-the-blank"
            icon={PiNoteBlankFill}
            className={`text-white p-2.5 hover:bg-secondary ${
              location.pathname === "/fill-in-the-blank"
                ? "bg-secondary text-black active"
                : ""
            }`}
          >
            Fill-in-the-blank
          </Sidebar.Item>
          <Sidebar.Item
            as={Link}
            to="/matching"
            icon={MdOutlineCompareArrows}
            className={`text-white p-2.5 hover:bg-secondary ${
              location.pathname === "/matching"
                ? "bg-secondary text-black active"
                : ""
            }`}
          >
            Matching
          </Sidebar.Item>
          <Sidebar.Item
            as={Link}
            to="/essay"
            icon={GiNotebook}
            className={`text-white p-2.5 hover:bg-secondary ${
              location.pathname === "/essay"
                ? "bg-secondary text-black active"
                : ""
            }`}
          >
            Essay
          </Sidebar.Item>
          <Sidebar.Item
            as={Link}
            to="/ranking-ordering"
            icon={FaRankingStar}
            className={`text-white p-2.5 hover:bg-secondary ${
              location.pathname === "/ranking-ordering"
                ? "bg-secondary text-black active"
                : ""
            }`}
          >
            Ranking/Ordering
          </Sidebar.Item>
          <Sidebar.Item
            as={Link}
            to="/numerical-response"
            icon={TiSortNumericallyOutline}
            className={`text-white p-2.5 hover:bg-secondary ${
              location.pathname === "/numerical-response"
                ? "bg-secondary text-black active"
                : ""
            }`}
          >
            Numerical response
          </Sidebar.Item>
          <Sidebar.Item
            as={Link}
            to="/account"
            icon={MdOutlineAccountCircle}
            className={`text-white p-2.5 hover:bg-secondary absolute bottom-5 w-full account_menu ${
              location.pathname === "/account"
                ? "bg-secondary text-black active"
                : ""
            }`}
          >
            Account
          </Sidebar.Item>
        </Sidebar.ItemGroup>
      </Sidebar.Items>
    </Sidebar>
  );
}